var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.683 8.1665V16.4998H2.34961V8.1665",
    stroke: "#555555",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.43416 4.74025C0.796843 6.39071 2.02614 8.16667 3.79536 8.16667C5.17607 8.16667 6.30303 7.04737 6.30303 5.66667C6.30303 7.04737 7.42232 8.16667 8.80303 8.16667H9.22736C10.6081 8.16667 11.7274 7.04737 11.7274 5.66667C11.7274 7.04737 12.8548 8.16667 14.2355 8.16667C16.0057 8.16667 17.2361 6.38967 16.5983 4.73846L15.3472 1.5H2.68537L1.43416 4.74025Z",
    stroke: "#555555",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopHome);
export default "https://c.d2cgo.com/dtc_center-setting/v19/assets/static/media/shop-home.6d202490929698b11a84c28fdb63f5b9.svg";
export { ForwardRef as ReactComponent };